/**
 * Resolve a stored video reference to a fully-qualified URL.
 *
 * Frontmatter stores S3 keys (e.g. `videos/foo/scroll.mp4`). In production we
 * prepend `PUBLIC_ASSET_CDN` so the browser streams straight from CloudFront.
 * In dev, if the env var is absent, we fall back to serving the file from the
 * local public/ directory so `npm run dev` still previews captured videos.
 *
 * Absolute URLs (legacy frontmatter, or anything already pointing to an https
 * origin) are passed through untouched.
 */
export function resolveVideoUrl(key?: string): string | undefined {
    if (!key) return undefined;
    if (/^https?:\/\//.test(key)) return key;

    const cdn = import.meta.env.PUBLIC_ASSET_CDN;
    if (!cdn) {
        return key.startsWith('/') ? key : `/${key}`;
    }

    if (!/^https?:\/\//.test(cdn)) {
        throw new Error(
            `PUBLIC_ASSET_CDN must include a protocol (e.g. https://...). Got: "${cdn}"`,
        );
    }

    return `${cdn.replace(/\/$/, '')}/${key.replace(/^\//, '')}`;
}
